module.exports = __webpack_public_path__ + "static/images/jf-activity-bg03.2767f44.png";